import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

import {
  Button,
} from 'web-components';

export const Item = styled(Flex)`
  position: relative;
  height: 32px;
  margin-top: 5px;
  margin-bottom: 5px;
  outline: none;
  overflow: hidden;
  border: 1px solid ${props => props.theme.colors.propertyColor};
  border-radius: 50px;
  margin-left:  10px;

  &:hover {
    button {
      opacity: 1;
    }
  }
`;

export const Label = styled(Flex).attrs({
  align: 'center',
  padding: '6px 11px 7px 11px',
  spacing: 5,
})`
  color: ${props => props.theme.colors.propertyColor};
  font-size: 12px;
  background-color: #fff;
  transition: all 0.2s ease-in;
  padding-right: ${props => (props.readOnly ? 11 : 23)}px;
  border: none;
  outline: none;

  ${props => props.readOnly && `
    border: 1px solid ${props.theme.colors.propertyColor};
    border-radius: 50px;
    margin: 2px 0;
  `};

  @media print {
    color: #000;
    font-size: 18px;
    border: none;
  }
`;

export const Remove = styled(Button).attrs({
  appearance: 'link',
})`
  position: absolute;
  top: 7px;
  right: 5px;
  color: ${props => props.theme.colors.danger} !important;
  font-size: 11px;
  transition: all 0.4s ease-in;
  opacity: 0;
`;
